import isEqual from 'lodash.isequal';

const mergeArray = (...arrays) => {
  let jointArray = [];
  arrays.forEach( (array) => {
    jointArray = [...jointArray, ...array]
  })
  const uniqueArray = jointArray.reduce((newArray, item, index) => {
    if (newArray.findIndex((arr) => isEqual(arr, item)) === -1) return [...newArray, item]
    return newArray
  }, [])

  return uniqueArray
}

export default mergeArray;
